export default "__VITE_PUBLIC_ASSET__20d0e1ef__"